import { SelfService } from "@/models/selfService.model";
import { axiosInstance } from "./axiosInstance";

export const getSelfServiceById = async (id: string): Promise<SelfService> => {
  try {
    const response = await axiosInstance.get<SelfService>(
      `/api/selfservice/${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllActiveSelfServiceCampaignsByCorbanId = async (): Promise<
  SelfService[]
> => {
  const response = await axiosInstance.get<SelfService[]>(
    `/api/selfservice/get-all-active-selfservice-campaigns`
  );
  return response.data;
};

export const updateSelfService = async (
  id: string,
  data: Partial<SelfService>
): Promise<SelfService> => {
  try {
    const response = await axiosInstance.put<SelfService>(
      `/api/selfservice/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAllSupportPhones = async (
  corbanId: number,
  supportPhone: string
): Promise<SelfService> => {
  try {
    const response = await axiosInstance.put<SelfService>(
      `/api/selfservice/suportphone`,
      {
        corbanId,
        supportPhone,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSupportPhoneByCorbanId = async (
  corbanId: string
): Promise<SelfService> => {
  try {
    if (!corbanId) {
      throw new Error("O parâmetro corbanId é obrigatório.");
    }

    const response = await axiosInstance.get<SelfService>(
      `api/selfservice/suportphone`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSelfServiceBySlug = async (
  slug?: string,
  slugSeller?: string,
  slugSelfService?: string,
): Promise<SelfService> => {
  try {
    const response = await axiosInstance.get<SelfService>(
      `/api/selfservice/slug`,
      {
        params: {
          slug,
          slugSeller,
          slugSelfService,
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSelfService = async (id: string): Promise<void> => {
  try {
    await axiosInstance.delete(`/api/selfservice/${id}`);
  } catch (error) {
    throw error;
  }
};

export const createSelfService = async (
  data: Partial<SelfService>
): Promise<SelfService> => {
  try {
    const response = await axiosInstance.post<SelfService>(
      `/api/selfservice`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const distributeLeads = async (): Promise<SelfService> => {
  try {
    const response = await axiosInstance.post<SelfService>(
      `/api/selfservice/distribute-leads`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
